import { LayoutDashboard, Wallet, TrendingUp, LogOut, Settings } from 'lucide-react';
import FxTicker from '../FxTicker';
import { memberLabel } from '../../lib/theme';

const TABS = [
  { icon: LayoutDashboard, label: 'Dashboard', page: 'dashboard' },
  { icon: Wallet, label: 'Actual', page: 'actual' },
  { icon: TrendingUp, label: 'Planning', page: 'planning' },
];

export default function TopNav({ onLogout, activePage = 'dashboard', onNavigate, onOpenSettings, members = {} }) {
  const name = memberLabel('PRANAV', members);
  const avatar = members?.PRANAV?.avatar;
  return (
    <header className="sticky top-0 z-40 flex flex-col md:relative md:flex-row md:items-center md:justify-between px-3 md:px-6 pt-2 md:pt-0 pb-2 md:pb-0 gap-2 md:gap-0"
      style={{ minHeight: '64px', background: 'var(--topbar, rgba(20,20,20,0.85))', backdropFilter: 'blur(16px)', borderBottom: '1px solid var(--surface-border, rgba(255,255,255,0.06))' }}>
      {/* Row 1 on mobile: right cluster only. On desktop: spacer for centered absolute nav. */}
      <div className="flex items-center justify-end gap-2 md:hidden">
        <FxTicker />
        <div className="flex items-center gap-2" title={`Signed in as ${name}`}>
          {avatar ? (
            <img src={avatar} alt={name} className="w-9 h-9 rounded-full object-cover flex-shrink-0"
              style={{ border: '1.5px solid var(--accent-glow, rgba(249,115,22,0.6))' }} />
          ) : (
            <div className="w-9 h-9 rounded-full flex items-center justify-center text-xs font-bold font-display flex-shrink-0"
              style={{ background: 'var(--accent-grad)', color: '#fff' }}>{name.charAt(0).toUpperCase()}</div>
          )}
        </div>
        <button onClick={onOpenSettings} title="Settings" aria-label="Settings"
          className="w-11 h-11 flex items-center justify-center rounded-lg transition-colors" style={{ color: 'var(--text-dim, rgba(255,255,255,0.5))' }}>
          <Settings size={20} strokeWidth={1.6} />
        </button>
        <button onClick={onLogout} title="Sign out" aria-label="Sign out"
          className="w-11 h-11 flex items-center justify-center rounded-lg transition-colors" style={{ color: 'var(--text-dim, rgba(255,255,255,0.5))' }}>
          <LogOut size={19} strokeWidth={1.6} />
        </button>
      </div>

      {/* desktop-only left spacer (keeps absolute-centered nav balanced) */}
      <div aria-hidden="true" className="hidden md:block" />

      <nav className="flex items-center justify-center gap-1 p-1 rounded-full self-center md:absolute md:left-1/2 md:-translate-x-1/2" style={{ background: 'var(--surface, rgba(255,255,255,0.04))', border: '1px solid var(--surface-border, rgba(255,255,255,0.06))' }}>
        {TABS.map(({ icon: Icon, label, page }) => {
          const active = activePage === page;
          return (
            <button key={page} onClick={() => onNavigate(page)}
              className="flex items-center gap-2 px-4 py-2.5 min-h-11 rounded-full text-sm md:text-base font-medium transition-all"
              style={{ background: active ? 'var(--accent-grad)' : 'transparent', color: active ? '#fff' : 'var(--text-dim, rgba(255,255,255,0.5))', boxShadow: active ? '0 2px 8px var(--accent-glow)' : 'none' }}>
              <Icon size={16} strokeWidth={active ? 2.2 : 1.6} /><span>{label}</span>
            </button>
          );
        })}
      </nav>

      {/* desktop right cluster */}
      <div className="hidden md:flex items-center gap-2">
        <FxTicker />
        <div className="flex items-center gap-2 pr-1" title={`Signed in as ${name}`}>
          {avatar ? (
            <img src={avatar} alt={name} className="w-8 h-8 rounded-full object-cover flex-shrink-0"
              style={{ border: '1.5px solid var(--accent-glow, rgba(249,115,22,0.6))' }} />
          ) : (
            <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold font-display flex-shrink-0"
              style={{ background: 'var(--accent-grad)', color: '#fff' }}>{name.charAt(0).toUpperCase()}</div>
          )}
          <span className="text-sm font-semibold" style={{ color: 'var(--text)' }}>{name}</span>
        </div>
        <button onClick={onOpenSettings} title="Settings" aria-label="Settings"
          className="w-9 h-9 flex items-center justify-center rounded-lg transition-colors" style={{ color: 'var(--text-dim, rgba(255,255,255,0.5))' }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; }} onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}>
          <Settings size={18} strokeWidth={1.6} />
        </button>
        <button onClick={onLogout} title="Sign out" aria-label="Sign out"
          className="w-9 h-9 flex items-center justify-center rounded-lg transition-colors" style={{ color: 'var(--text-dim, rgba(255,255,255,0.5))' }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; }} onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}>
          <LogOut size={17} strokeWidth={1.6} />
        </button>
      </div>
    </header>
  );
}
